import React, { lazy } from "react";
import { Route } from "react-router-dom";

const KYC = lazy(() => import("../pages/kyc"));
const MinimumKyc = lazy(() => import("../pages/kyc/minKYC"));
const DodumentKyc = lazy(() => import("../pages/kyc/documentKYC"));
const EmployeeProfile = lazy(() => import("../pages/newemployeeprofile"));

const Password = lazy(() => import("../components/settings/password"));
const KycUpload = lazy(() => import("../components/settings/delegation"));
const Delegation = lazy(() => import("../components/settings/delegation"));
const EditProfile = lazy(() => import("../components/settings/editprofile"));
const RoleApprover = lazy(() => import("../components/settings/roleApprover"));
const LanguageSetting = lazy(() => import("../components/settings/languageSetting"));
const ManageSuperiors = lazy(() => import("../components/settings/managesuperiors"));
const SocialConnectors = lazy(() => import("../components/settings/socialconnectors"));
const HappayAccountManager = lazy(() => import("../components/settings/happayaccountmanager"));
const UserCurrencyConversion = lazy(() => import("../components/settings/userCurrencyConversion"));
const Userlevelnotifications = lazy(() => import("../components/settings/userlevelnotifications"));
const ConstructCurrencyRangeView = lazy(() => import("../components/settings/currencyRangeParent"));

const ProfileRoutes = [
    <Route exact path="/profile/editprofile" component={EmployeeProfile} />,

    <Route exact path="/profile/companyprofile" component={EditProfile} />,

    <Route exact path="/profile/happayaccountmanager" component={HappayAccountManager} />,

    <Route exact path="/profile/managesuperiors" component={ManageSuperiors} />,

    <Route exact path="/profile/roleapprover" component={RoleApprover} />,

    <Route exact path="/profile/password" component={Password} />,

    <Route exact path="/profile/delegation" component={Delegation} />,

    <Route exact path="/profile/socialConnectors" component={SocialConnectors} />,

    <Route exact path="/profile/kyc" component={KYC} />,

    <Route exact path="/profile/minKyc" component={MinimumKyc} />,

    <Route exact path="/profile/documentKyc" component={DodumentKyc} />,

    <Route exact path="/profile/kycupload" component={KycUpload} />,

    <Route exact path="/profile/langSetting" component={LanguageSetting} />,

    <Route
        exact
        path={["/profile/constructCurrencyRange", "/profile/constructCurrencyRange(:/id)"]}
        pageType="userProfile"
        component={ConstructCurrencyRangeView}
    />,

    <Route exact path="/profile/userCurrencyConversion" component={UserCurrencyConversion} />,

    <Route exact path="/profile/userlevelnotifications" component={Userlevelnotifications} />
];

export default ProfileRoutes;
